// if decimals === false, return a number and not a string
export const asDecimal = (number, decimals = 2, removeZeros = false) => {
    if (typeof number !== 'number') number = parseFloat(number)

    let result = Math.round(number * 10 ** decimals) / 10 ** decimals // If 2 decimals, *100 and /100. If 3: 1000

    // * if -0.0, return 0
    if (isNullOrZero(result)) {
        result = 0
    } else if (decimals) {
        result = parseFloat(result.toFixed(decimals))

        // If removeZeros specified or if only 0 in decimals
        if (removeZeros || result.toString().endsWith('.' + '0'.repeat(decimals))) {
            result = parseFloat(result)
        }
    }

    return result
}

/**
 * Check if the value is equal to 0
 * works for 0 ; 0.0 ; 0° ; 00 ; 0G
 */
export const isNullOrZero = (value) => {
    if (typeof value === 'number') {
        return value === 0 || isNaN(value)
    } else {
        return value === null ? true : parseFloat(value.trim()) === 0
    }
}

/**
 * Returns a random number between a min value (included) and a max value (excluded)
 */
export const getRandomArbitrary = (min, max) => {
    return Math.random() * (max - min) + min
}

export const average = (arr) => arr.reduce((p, c) => p + c, 0) / arr.length

// A value was given: anything but undefined, null and the empty string (0 and false count).
export const hasValue = (value) => value !== undefined && value !== null && value !== ''

// A select's empty choice (Select.vue, Autocomplete.vue): only with an empty option label, the
// empty option's own value or no value. Takes the props, so emptyOptionValue is read only then.
export const isEmptyOptionValue = (value, props) =>
    props.emptyOptionLabel && (value === props.emptyOptionValue || !hasValue(value))

// A number (or digit string) on two digits: 1 → '01', for dates and durations.
export const pad = (value) => String(value).padStart(2, '0')

// The value as trimmed text, or null when it has no value or only blanks.
export const toNullableText = (value) => {
    if (!hasValue(value)) return null
    const text = String(value).trim()
    return text.length ? text : null
}

// The value as a finite number, or null when it has no value or is not one.
export const toNullableNumber = (value) => {
    if (!hasValue(value)) return null
    const number = Number(value)
    return Number.isFinite(number) ? number : null
}

export const parseNullableId = (value) => {
    if (value === undefined) return undefined
    if (value === null || value === '' || value === 'null') return null

    const parsedValue = Number(value)
    return Number.isNaN(parsedValue) ? null : parsedValue
}

export const parseNullableBoolean = (value) => {
    if (value === true || value === false) return value
    if (value === 1 || value === 0) return Boolean(value)
    if (value === '1') return true
    if (value === '0') return false

    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        if (normalized === 'true') return true
        if (normalized === 'false') return false

        const numericValue = Number(normalized)
        if (Number.isFinite(numericValue)) return Boolean(numericValue)
    }

    return null
}
